// This file should only contain action type constants.
export const SET_WIDGET_INFO = 'SET_WIDGET_INFO';
export const SET_ACCOUNT = 'SET_ACCOUNT';
export const SET_PRICING_MODULE = 'SET_PRICING_MODULE';
export const SET_USER_PROFILE = 'SET_USER_PROFILE';
export const SET_WIS_VEHICLE = 'SET_WIS_VEHICLE';
export const SET_SHOULD_PORTAL_PRICING = 'SET_SHOULD_PORTAL_PRICING';
export const SET_SHOULD_FETCH_GM_PAYMENTS = 'SET_SHOULD_FETCH_GM_PAYMENTS';
